import GET_CREATORS from '@/graphql/queries/creators/getCreators'
import GET_CREATORS_COUNT from '@/graphql/queries/creators/getCreatorsCount'
import Filters from '@/services/Filters/Filters'
import Creator from '@/ts/Creator'
import Aggregate from '@/ts/interfaces/global/Aggregate'

import useHasura from './useHasura'
import usePagination from './usePagination'

function useCreators() {
  const filters = Filters.get('creator_categories') || null
  const variables = { creator_categories: filters }

  const queryAggregate = useHasura<QueryAggregate>(
    'creators_aggregate',
    GET_CREATORS_COUNT,
    { variables }
  )

  const count = queryAggregate.data?.creators_aggregate?.aggregate?.count || 0

  const { limit, offset } = usePagination(count)
  const config = { enabled: count > 0 }

  const queryCreators = useHasura<QueryCreators>('creators', GET_CREATORS, {
    config,
    variables: { ...variables, limit, offset },
  })

  const isLoading = queryAggregate.isLoading || queryCreators.isLoading
  const creators = queryCreators.data?.creators || []

  return { creators, count, isLoading }
}

interface QueryCreators {
  creators: Creator[]
}

interface QueryAggregate {
  creators_aggregate: Aggregate
}

export default useCreators
